export default "__VITE_ASSET__BbBXPvX7__"